<ul class="navbar-nav">
  <li class="nav-item">
    <a
      class="nav-link"
      (keypress)="onToggleMenuSidebar()"
      tabindex="0"
      (click)="onToggleMenuSidebar()"
      role="button"
      ><i class="fas fa-bars"></i
    ></a>
  </li>
</ul>
<ng-container *ngIf="toggleVisible">
  <div
    class="background-overlay"
    (click)="toggleVisibleFlag()"
    tabindex="3"
    (keypress)="toggleVisibleFlag()"></div>
</ng-container>

<ul class="navbar-nav ml-auto">
  <li class="nav-item dropdown">
    <a
      class="nav-link"
      data-toggle="dropdown"
      tabindex="1"
      (keypress)="toggleVisibleFlag()"
      (click)="toggleVisibleFlag()">
      <i class="fas fa-power-off theme-color"></i>
    </a>
    <div
      class="dropdown-menu dropdown-menu-lg dropdown-menu-right"
      [ngClass]="toggleVisible ? 'show' : ''">
      <a
        (click)="logout()"
        (keypress)="logout()"
        tabindex="2"
        class="dropdown-item dropdown-header"
        ><span class="btn btn-block btn-default btn-flat">Sign Out</span></a
      >
    </div>
  </li>
</ul>
